module.exports = __webpack_public_path__ + "332a78cc.svg";